import { render } from "./Opmerkingen.vue?vue&type=template&id=b64c16fa&scoped=true"
import script from "./Opmerkingen.vue?vue&type=script&lang=js"
export * from "./Opmerkingen.vue?vue&type=script&lang=js"

import "./Opmerkingen.vue?vue&type=style&index=0&id=b64c16fa&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Documents/GIT_CLONES/skipiste/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b64c16fa"]])

export default __exports__